<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>ANIMAL MANAGEMENT MODULE</h2>
          <p>List of animal details </p>
          <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</a>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-lg-3 col-sm-3 col-12">
     <div class="form-group">
     <div id="reportrange_date" class="date_range mt-1">
     <i class="glyphicon glyphicon-calendar fa fa-calendar"></i>&nbsp;
     <span></span> <b class="caret"></b>
     </div>
     </div>
     </div>-->
        <!--<div class="col-lg-3 col-sm-3 col-12">
      <div class="form-group">
       <div id="reportrange_date" class="date_range mt-1">
       <i class="glyphicon glyphicon-calendar fa fa-calendar"></i>&nbsp;
       <span></span> <b class="caret"></b>
       </div>
       </div>
       </div>-->

        <!--<div class="col-lg-3 col-sm-3 col-12">
      <div class="form-group form_group bmd-form-group mt-0">
      <div class="input-group filter_with_search">
         <span class="input-group-btn">
             <button class="btn btn-default" type="button"><span class="fa fa-search"></span></button>
         </span>
         <input type="text"  class="form-control speciessearch" name="x" placeholder="Search term...">
         <div class="input-group-btn search-panel" data-search="students">
             <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
               <i class="fa fa-filter" aria-hidden="true"></i>
             </button>
             <ul class="dropdown-menu" role="menu">
               <li><a data-search="all">All</a></li>
               <li><a data-search="breed">Select by Breed</a></li>
               <li><a data-search="drug">Select by Drug Name</a></li>
               <li><a data-search="disease">Select by Disease Name</a></li>
               <li class="divider"></li>
             </ul>
         </div> 
         </div> 
      </div>
     </div>-->
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="card card_tab">
            <div class="card-header" [ngSwitch]="true">
              <!-- <img alt="" src="assets/images/rottweiler.jpg" class="img_circle" />-->
              <ng-container *ngFor="let DeathList of DeathListData; index as j">
                <div *ngSwitchCase="deathadd!=false" class="topcrudicon">
                  <button style="background-color: #1d3f67;box-shadow:none" class="btn size"
                    [class.disablebutton]="isDisabled" [disabled]="isDisabled"><i style="color:white;"
                      id="{{DeathList.tnam_dth_id}}" (click)="editAnimalDeath($event)"
                      class="fa fa-pencil-square-o icon_common edit" aria-hidden="true"></i></button>
                  <button style="background-color: #1d3f67;box-shadow:none" class="btn size"
                    [class.disablebutton]="isDisabled" [disabled]="isDisabled"><i style="color:white;"
                      id="{{DeathList.tnam_dth_id}}" (click)="Deathsweetdelete($event)"
                      class="fa fa-trash icon_common deletedata delete" aria-hidden="true"></i> </button>
                </div>
              </ng-container>

              <div *ngSwitchCase="generaladd!=false" class="topcrudicon">
                <div *ngFor="let GeneralList of GeneralListData">
                  <button style="background-color: #1d3f67;box-shadow:none" class="btn size"
                    [class.disablebutton]="isDisabled" [disabled]="isDisabled"><i style="color:white;"
                      id="{{GeneralList.tnsm_id}}" (click)="editAnimalGeneral($event)"
                      class="fa fa-pencil-square-o icon_common edit" aria-hidden="true"></i></button>
                  <button style="background-color: #1d3f67;box-shadow:none" class="btn size"
                    [class.disablebutton]="isDisabled" [disabled]="isDisabled"><i style="color:white;"
                      id="{{GeneralList.tnsm_id}}" (click)="Generalsweetdelete($event)"
                      class="fa fa-trash icon_common deletedata delete" aria-hidden="true"></i> </button>
                </div>
              </div>
              <h4 class="card-title card_title" [class.top]="topheadset" id="getanimalidprepopulate">{{animalidhead}}
              </h4>
            </div>
            <div class="card-body ">
              <ul class="nav nav-pills nav-pills-warning" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" data-toggle="tab" href="#General" (click)="AnimalGeneral()" role="tablist">
                    General
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#Vaccine" (click)="animalvaccine()" role="tablist">
                    Vaccine
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#Disease" (click)="animaldisease()" role="tablist">
                    Disease
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#Samples" (click)="animalsamples()" role="tablist">
                    Samples
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#Diagnostic" (click)="AnimalDiagnostic()" role="tablist">
                    Diagnostic
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#Deworming" (click)="AnimalDeworming()" role="tablist">
                    Deworming
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#Death" (click)="AnimalDeath()" role="tablist">
                    Death
                  </a>
                </li>
              </ul>
              <div class="row">
                <div class="col-lg-2 col-sm-2 col-12">
                </div>
                <div class="col-lg-2 col-sm-2 col-12">
                </div>
                <div class="col-lg-2 col-sm-2 col-12">
                </div>
                <div class="col-lg-2 col-sm-2 col-12">
                </div>
                <div class="col-lg-2 col-sm-2 col-12">
                </div>
                <div class="col-lg-1 col-sm-1 col-12" [ngSwitch]="true" [class.disablebutton]="isDisabled">
                  <div class="form-group" *ngSwitchCase="diseaseadd!=false">
                    <button class="btn btn-primary mt-0 mb-0 add" (click)="AddAnimalDisease()"><i class="fa fa-plus"
                        aria-hidden="true"></i> <span class="lengthchange">Add</span></button>
                  </div>
                  <div class="form-group" *ngSwitchCase="vaccineadd!=false">
                    <button class="btn btn-primary mt-0 mb-0 add" (click)="AddAnimalVaccine()"><i class="fa fa-plus"
                        aria-hidden="true"></i> <span class="lengthchange">Add</span></button>
                  </div>
                  <div class="form-group" *ngSwitchCase="samplesadd!=false">
                    <button class="btn btn-primary mt-0 mb-0 add" (click)="AddAnimalSamples()"><i class="fa fa-plus"
                        aria-hidden="true"></i> <span class="lengthchange">Add</span></button>
                  </div>
                  <div class="form-group" *ngSwitchCase="diagnosticadd!=false">
                    <button class="btn btn-primary mt-0 mb-0 add" (click)="AddAnimalDiagnostic()"><i class="fa fa-plus"
                        aria-hidden="true"></i> <span class="lengthchange">Add</span></button>
                  </div>
                  <div class="form-group" *ngSwitchCase="dewormingadd!=false">
                    <button class="btn btn-primary mt-0 mb-0 add" (click)="AddAnimalDeworming()"><i class="fa fa-plus"
                        aria-hidden="true"></i> <span class="lengthchange">Add</span></button>
                  </div>
                  <div class="form-group" *ngSwitchCase="deathadd!=false">
                    <button class="btn btn-primary mt-0 mb-0 add" (click)="AddAnimalDeath()"><i class="fa fa-plus"
                        aria-hidden="true"></i> <span class="lengthchange">Add</span></button>
                  </div>

                </div>

              </div>
              <div class="tab-content tab-space">
                <div class="tab-pane active" id="General" *ngFor="let GeneralList of GeneralListData; index as j">
                  <div class="row">
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Farm:&nbsp;&nbsp;<span>{{GeneralList.farm_name}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Species:&nbsp;&nbsp;<span>{{GeneralList.species_name}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Breed:&nbsp;&nbsp;<span>{{GeneralList.breed_name}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Gender:&nbsp;&nbsp;<span>{{GeneralList.tnsm_sex}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte nowrap">Age Group:&nbsp;&nbsp;<span>{{GeneralList.age_group}} /
                          {{GeneralList.weeks}} days</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Weight:&nbsp;&nbsp;<span>{{GeneralList.tnsm_weight}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Date Of Birth:&nbsp;&nbsp;<span> {{GeneralList.tnsm_date_of_birth | date:
                          'dd/MM/yyyy'}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Date Of Transfer:&nbsp;&nbsp;<span>{{GeneralList.tnsm_date_of_transfer | date:
                          'dd/MM/yyyy'}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Date Of Purchase:&nbsp;&nbsp;<span>{{GeneralList.tnsm_date_of_purchase | date:
                          'dd/MM/yyyy'}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Date Of Deletion:&nbsp;&nbsp;<span>{{GeneralList.tnsm_date_of_deletion | date:
                          'dd/MM/yyyy'}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Status:&nbsp;&nbsp;<span class="green"
                          *ngIf="GeneralList.tnsm_status==1">Active</span>
                        <span class="red" *ngIf="GeneralList.tnsm_status==0">Inactive</span>
                      </p>
                    </div>
                  </div>
                </div>

                <!--<div class="tab-pane active" id="General">
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-12">
                  <table id="myTable7" class="table table-bordered">
                  <thead>
                  <tr>
                  <th>S.No</th>
                  <th>Animal Type</th>
                  <th>Species</th>
                  <th>Breed</th>
                  <th>Gender</th>
                  <th>Age</th>
                  <th>Weight</th>
                  <th>Date Of Birth</th>
                  <th>Date Of Transfer</th>
                  <th>Date Of Purchase</th>
                  <th>Date Of Deletion</th>
                  <td>Action</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let GeneralList of GeneralListData; index as j">
                  <td>{{j+1}}</td>
                  <td>{{GeneralList.tnam_gen_type}}</td>
                  <td>{{GeneralList.species_name}}</td>
                  <td>{{GeneralList.breed_name}}</td>
                  <td>{{GeneralList.tnam_gen_sex}}</td>
                  <td *ngIf="GeneralList.tnsm_age==1">Younger</td>
                  <td *ngIf="GeneralList.tnsm_age==2">Grower</td>
                  <td>{{GeneralList.tnsm_weight}}</td>
                  <td>{{GeneralList.tnam_gen_date_of_birth | date: 'MM/dd/yyyy'}}</td>
                  <td>{{GeneralList.tnam_gen_date_of_transfer | date: 'MM/dd/yyyy'}}</td>
                  <td>{{GeneralList.tnam_gen_date_of_purchase | date: 'MM/dd/yyyy'}}</td>
                  <td>{{GeneralList.tnam_gen_date_of_deletion | date: 'MM/dd/yyyy'}}</td>
                 
                  <td>
                   <button class="btn size"  ><i id="{{GeneralList.tnam_gen_id}}"  (click)= "viewAnimalGeneral($event)" class="fa fa-file-text icon_common"   aria-hidden="true"></i></button>
                   <button  class="btn size"  ><i  id="{{GeneralList.tnam_gen_id}}"  (click)= "editAnimalGeneral($event)" class="fa fa-pencil-square-o icon_common edit" aria-hidden="true"></i></button>
                   <button  class="btn size"  ><i id="{{GeneralList.tnam_gen_id}}"  (click)="Generalsweetdelete($event)" class="fa fa-trash icon_common deletedata delete"   aria-hidden="true"></i> </button>
                   </td>
                    </tr>
                  </tbody>
                  </table>
                </div>
               </div>
             </div>-->
                <div class="tab-pane" id="Vaccine">
                  <!-- Animal Details Section -->
                  <div class="row" *ngFor="let GeneralList of GeneralListData; index as j">
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Farm:&nbsp;&nbsp;<span>{{GeneralList.farm_name}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Species:&nbsp;&nbsp;<span>{{GeneralList.species_name}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Breed:&nbsp;&nbsp;<span>{{GeneralList.breed_name}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Gender:&nbsp;&nbsp;<span>{{GeneralList.tnsm_sex}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte nowrap">Age Group:&nbsp;&nbsp;<span>{{GeneralList.age_group}} / {{GeneralList.weeks}} days</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Weight:&nbsp;&nbsp;<span>{{GeneralList.tnsm_weight}}</span></p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 col-sm-12 col-12">
                      <div class="table-responsive">
                        <table id="myTable1" class="table table-bordered">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Vaccine Name</th>
                              <th>Batch No</th>
                              <th>Expiry Date</th>
                              <th>Dose Value/Unit</th>
                              <th>Vaccine Date 1</th>
                              <th>Remark</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let vaccineList of vaccineListData; index as j">
                              <td>{{j+1}}</td>
                              <td>{{vaccineList.tnam_vac_vaccine_name}}</td>
                              <td>{{vaccineList.tnam_vac_batch_number}}</td>
                              <td>{{vaccineList.tnam_vac_expiry_date | date: 'dd/MM/yyyy'}}</td>
                              <td>{{vaccineList.tnam_vac_dose_value}}&nbsp;{{vaccineList.tnam_vac_units}}</td>
                              <td>{{vaccineList.tnam_vac_date_of_first_vaccine | date: 'dd/MM/yyyy'}}</td>
                              <td>{{vaccineList.tnam_vac_date_of_second_vaccine}}</td>
                              <td>
                                <div class="nowrap">
                                  <span><i class="btn size button" id="{{vaccineList.tnam_vac_id}}"
                                      (click)="viewAnimalVaccine($event)" class="fa fa-file-text icon_common"
                                      aria-hidden="true"></i></span>
                                  <span [class.disablebutton]="isDisabled"><i class="btn size button"
                                      id="{{vaccineList.tnam_vac_id}}" (click)="editAnimalVaccine($event)"
                                      class="fa fa-pencil-square-o icon_common edit" aria-hidden="true"></i></span>
                                  <span [class.disablebutton]="isDisabled"><i class="btn size button"
                                      id="{{vaccineList.tnam_vac_id}}" (click)="Vaccinesweetdelete($event)"
                                      class="fa fa-trash icon_common deletedata delete" aria-hidden="true"></i> </span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="Disease">
                  <!-- Animal Details Section -->
                  <div class="row" *ngFor="let GeneralList of GeneralListData; index as j">
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Farm:&nbsp;&nbsp;<span>{{GeneralList.farm_name}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Species:&nbsp;&nbsp;<span>{{GeneralList.species_name}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Breed:&nbsp;&nbsp;<span>{{GeneralList.breed_name}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Gender:&nbsp;&nbsp;<span>{{GeneralList.tnsm_sex}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte nowrap">Age Group:&nbsp;&nbsp;<span>{{GeneralList.age_group}} / {{GeneralList.weeks}} days</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                      <p class="clrwhte">Weight:&nbsp;&nbsp;<span>{{GeneralList.tnsm_weight}}</span></p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 col-sm-12 col-12">
                      <div class="table-responsive">
                        <table id="myTable2" class="table table-bordered">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Disease Name</th>
                              <th>Drug Name</th>
                              <th>Dose Value/Units</th>
                              <th>Date of Discovery</th>
                              <th>Treatment Given</th>
                              <th>Description</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let diseaseList of diseaseListData; index as j">
                              <td>{{j+1}}</td>
                              <td>{{diseaseList.tnam_dis_disease_name}}</td>
                              <td>{{diseaseList.tnam_dis_drug_name}}</td>
                              <td>{{diseaseList.tnam_dis_dose_value}}&nbsp;{{diseaseList.tnam_dis_units}}</td>
                              <td>{{diseaseList.tnam_dis_date_of_discovery | date: 'dd/MM/yyyy'}}</td>
                              <td>{{diseaseList.tnam_dis_treatment_given}}</td>
                              <td>{{diseaseList.tnam_dis_disease_description}}</td>
                              <td>
                                <div class="nowrap">
                                  <span> <i class="btn size button" id="{{diseaseList.tnam_dis_id}}"
                                      (click)="viewAnimalDisease($event)" class="fa fa-file-text icon_common"
                                      aria-hidden="true"></i></span>
                                  <span [class.disablebutton]="isDisabled"> <i class="btn size button"
                                      id="{{diseaseList.tnam_dis_id}}" (click)="editAnimalDisease($event)"
                                      class="fa fa-pencil-square-o icon_common edit" aria-hidden="true"></i></span>
                                  <span [class.disablebutton]="isDisabled"> <i class="btn size button"
                                      id="{{diseaseList.tnam_dis_id}}" (click)="Diseasesweetdelete($event)"
                                      class="fa fa-trash icon_common deletedata delete" aria-hidden="true"></i> </span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="Samples">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12 col-12">
                      <div class="table-responsive">
                        <table id="myTable3" class="table table-bordered">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Samples Date</th>
                              <th>Samples Collected</th>
                              <th>Description</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let sampleslist of samplesListData; index as j">
                              <td>{{j+1}}</td>
                              <td>{{sampleslist.tnam_sam_date_of_sample_collected | date: 'dd/MM/yyyy'}}</td>
                              <td>{{sampleslist.tnam_sam_sample_collected}}</td>
                              <td>{{sampleslist.tnam_sam_description}}</td>
                              <td>
                                <div class="nowrap">
                                  <span> <i class="btn size button" id="{{sampleslist.tnam_sam_id}}"
                                      (click)="viewAnimalsamples($event)" class="fa fa-file-text icon_common"
                                      aria-hidden="true"></i></span>
                                  <span [class.disablebutton]="isDisabled"> <i class="btn size button"
                                      id="{{sampleslist.tnam_sam_id}}" (click)="editAnimalsamples($event)"
                                      class="fa fa-pencil-square-o icon_common edit" aria-hidden="true"></i></span>
                                  <span [class.disablebutton]="isDisabled"> <i class="btn size button"
                                      id="{{sampleslist.tnam_sam_id}}" (click)="Samplessweetdelete($event)"
                                      class="fa fa-trash icon_common deletedata delete" aria-hidden="true"></i></span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="Diagnostic">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12 col-12">
                      <table id="myTable4" class="table table-bordered">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Diagnostic Test Name</th>
                            <th>Date of Test</th>
                            <th>Test Description</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let DiagnosticList of DiagnosticListData; index as j">
                            <td>{{j+1}}</td>
                            <td>{{DiagnosticList.tnam_dgn_diagnostics_test_name}}</td>
                            <td>{{DiagnosticList.tnam_dgn_date_of_test | date: 'dd/MM/yyyy'}}</td>
                            <td>{{DiagnosticList.tnam_dgn_diagnostics_description}}</td>
                            <td>
                              <div class="nowrap">
                                <span> <i class="btn size button" id="{{DiagnosticList.tnam_dgn_id}}"
                                    (click)="viewAnimaldiagnostic($event)" class="fa fa-file-text icon_common"
                                    aria-hidden="true"></i></span>
                                <span [class.disablebutton]="isDisabled"> <i class="btn size button"
                                    id="{{DiagnosticList.tnam_dgn_id}}" (click)="editAnimaldiagnostic($event)"
                                    class="fa fa-pencil-square-o icon_common edit" aria-hidden="true"></i></span>
                                <span [class.disablebutton]="isDisabled"> <i class="btn size button"
                                    id="{{DiagnosticList.tnam_dgn_id}}" (click)="Diagnosticsweetdelete($event)"
                                    class="fa fa-trash icon_common deletedata delete" aria-hidden="true"></i></span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="Deworming">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12 col-12">
                      <table id="myTable5" class="table table-bordered">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Deworming Name</th>
                            <th>Deworming Date</th>
                            <th>Batch No</th>
                            <th>Expiry Date</th>
                            <th>Description</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let DewormingList of DewormingListData; index as j">
                            <td>{{j+1}}</td>
                            <td>{{DewormingList.tnam_dew_deworming_name}}
                            <td>{{DewormingList.tnam_dew_deworming_date | date: 'dd/MM/yyyy'}}</td>
                            <td>{{DewormingList.tnam_dew_batch_number}}</td>
                            <td>{{DewormingList.tnam_dew_expiry_date | date: 'dd/MM/yyyy'}}</td>
                            <td>{{DewormingList.tnam_dew_deworming_description}}</td>
                            <td>
                              <div class="nowrap">
                                <span> <i class="btn size button" id="{{DewormingList.tnam_dew_id}}"
                                    (click)="viewAnimaldeworming($event)" class="fa fa-file-text icon_common"
                                    aria-hidden="true"></i></span>
                                <span [class.disablebutton]="isDisabled"> <i class="btn size button"
                                    id="{{DewormingList.tnam_dew_id}}" (click)="editAnimaldeworming($event)"
                                    class="fa fa-pencil-square-o icon_common edit" aria-hidden="true"></i></span>
                                <span [class.disablebutton]="isDisabled"> <i class="btn size button"
                                    id="{{DewormingList.tnam_dew_id}}" (click)="Dewormingsweetdelete($event)"
                                    class="fa fa-trash icon_common deletedata delete" aria-hidden="true"></i> </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="Death">
                  <ng-container *ngFor="let DeathList of DeathListData; index as j">
                    <div class="row">
                      <div class="col-lg-2 col-sm-3 col-12">
                        <p class="clrwhte"><strong>Date Of Death:&nbsp;&nbsp;</strong></p>
                      </div>
                      <div class="col-lg-10 col-sm-9 col-12">
                        <p class="clrwhte">{{DeathList.tnam_dth_date_of_death | date: 'dd/MM/yyyy'}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-2 col-sm-3 col-12">
                        <p class="clrwhte"><strong>Causes Of Death:</strong></p>
                      </div>
                      <div class="col-lg-10 col-sm-9 col-12">
                        <p class="clrwhte">{{DeathList.tnam_dth_cause_of_death}}</p>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <!--<div class="tab-pane" id="Death"  >
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-12">
                  <table id="myTable6" class="table table-bordered">
                  <thead>
                  <tr>
                  <th>S.No</th>
                  <th>Date Of Death </th>
                  <th>Causes Of Death </th>
                  <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let DeathList of DeathListData; index as j">
                  <td>{{j+1}}</td>
                  <td>{{DeathList.tnam_dth_date_of_death | date: 'MM/dd/yyyy'}}</td>
                  <td>{{DeathList.tnam_dth_cause_of_death}}</td>
                  <td>
                   <button class="btn size"  ><i id="{{DeathList.tnam_dth_id}}"  (click)= "viewAnimalDeath($event)" class="fa fa-file-text icon_common"   aria-hidden="true"></i></button>
                   <button  class="btn size"  ><i  id="{{DeathList.tnam_dth_id}}"  (click)= "editAnimalDeath($event)" class="fa fa-pencil-square-o icon_common edit" aria-hidden="true"></i></button>
                   <button  class="btn size"  ><i id="{{DeathList.tnam_dth_id}}"  (click)="Deathsweetdelete($event)" class="fa fa-trash icon_common deletedata delete"   aria-hidden="true"></i> </button>
                   </td>
                    </tr>
                  </tbody>
                  </table>
                </div>
               </div>
         </div>-->

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
